module.exports = __webpack_public_path__ + "img/electronic_electric_pending_zone.b8461b25.svg";